import React from 'react'

import { CategoryType, STACK } from 'types/deck'

import { useActionless, useActions, useAppSelector } from 'redux/hooks'
import { toggleModal as toggleModalAction } from 'redux/active/actions'
import { SET_ACTIVE_STATE } from 'redux/active/actions/types'

import CategoryModal from 'components/deckPage/categories/Modal'

import { getMultiSelectedUpdates, getNewCategories } from 'utils/CategoryChangeHelpers'
import saveService from 'services/save.service'

const NewCategoryDropZoneModal = () => {
  const newCategoryDrop = useAppSelector(state => state.active.modals.newCategoryDrop)

  const [toggleModal] = useActions(toggleModalAction)
  const [setActiveState] = useActionless(SET_ACTIVE_STATE)

  const card = newCategoryDrop?.card
  const sourceStack = newCategoryDrop?.sourceStack
  const multiSelectedIds = newCategoryDrop?.multiSelectedIds

  const handleSubmit = (category: CategoryType) => {
    if (multiSelectedIds) {
      const updatedCards = getMultiSelectedUpdates(multiSelectedIds, '', category.name)

      return saveService.save(updatedCards).then(() => {
        setActiveState({ multiSelectedIds: {} })
        handleCloseModal()
      })
    }

    const updatedCategories = getNewCategories(card.categories, STACK.CUSTOM, sourceStack, category.name)

    return saveService.save([{ ...card, qty: card.qty || 1, categories: updatedCategories }]).then(() => {
      handleCloseModal()
    })
  }

  const handleCloseModal = () => toggleModal('newCategoryDrop', null)

  return <CategoryModal open={!!newCategoryDrop} onClose={handleCloseModal} onSave={handleSubmit} />
}

export default NewCategoryDropZoneModal
